import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import { useStylesMenu, useStylesMenuItem, useStylesMask } from './styles';

const DropdownMenu = ({ handleLogout, ...props }) => {
  const classesMenu = useStylesMenu();
  const classesMenuItem = useStylesMenuItem();
  const classesMask = useStylesMask();

  return (
    <Menu
      keepMounted
      {...props}
      classes={classesMenu}
      PopoverClasses={classesMask}
    >
      <MenuItem onClick={handleLogout} classes={classesMenuItem}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </MenuItem>
    </Menu>
  );
};

export default DropdownMenu;
